import { render, staticRenderFns } from "./ManageSignature.vue?vue&type=template&id=645d4e0c"
import script from "./ManageSignature.vue?vue&type=script&lang=js"
export * from "./ManageSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports